import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: 'processor-selection',
    loadComponent: () =>
      import(
        '@features/processor-selection-container/processor-selection-container.component'
      ).then(m => m.ProcessorSelectionContainerComponent)
  },
  {
    path: 'voucher/:merchantId/:operationId',
    loadComponent: () =>
      import(
        '@features/direct-connections-voucher-container/direct-connections-voucher-container.component'
      ).then(m => m.DirectConnectionsVoucherContainerComponent)
  },
  {
    path: 'voucher/V2/:merchantId/:operationId',
    loadComponent: () =>
      import(
        '@features/voucher-V2-template/voucher-v2-template.component'
      ).then(m => m.VoucherV2TemplateComponent)
  },
  {
    path: 'voucher/V4/:merchantId/:operationId',
    loadComponent: () =>
      import(
        '@features/voucher-V3-template/voucher-v3-template.component'
      ).then(m => m.VoucherV3TemplateComponent)
  },
  {
    path: 'error',
    loadComponent: () =>
      import('@core/components/error-page/error-page.component').then(
        m => m.ErrorPageComponent
      )
  },
  {
    path: '**',
    loadComponent: () =>
      import('@core/components/not-found/not-found.component').then(
        m => m.NotFoundPageComponent
      )
  }
];
